import React from "react";
import { FaAddressBook } from "react-icons/fa";
import { GiGiftOfKnowledge } from "react-icons/gi";
import { IoTrendingUpOutline } from "react-icons/io5";
import CircularProgress from "./CircularProgress";
import { Link } from "react-router-dom";
const Dashboard = () => {
  return (
    <div className="w-full flex flex-col gap-8 ">
      {/* main-1 */}
      <div className="w-full flex lg:flex-row flex-col gap-8">
        <div className="lg:w-3/4 w-full flex flex-col gap-8 ">
          <div className="w-full flex gap-4 items-center xl:flex-nowrap flex-wrap">
            {/* course card */}
            <div className="xl:w-1/3 w-full bg-[#00294B] p-4 rounded-md flex gap-4 items-center">
              <div className="w-[3rem] h-[3rem] bg-[#00CAFF] rounded-full flex justify-center items-center">
                <span>
                  <FaAddressBook />
                </span>
              </div>
              <div className="flex flex-col">
                <span className="text-white text-xl font-bold">0</span>
                <span className="text-base text-green-200">
                  Course Completed
                </span>
              </div>
            </div>
            {/* certificate card */}
            <div className="xl:w-1/3 w-full bg-[#00294B] p-4 rounded-md flex gap-4 items-center ">
              <div className="w-[3rem] h-[3rem] bg-yellow-500 rounded-full flex justify-center items-center">
                <span>
                  <GiGiftOfKnowledge />
                </span>
              </div>
              <div className="flex flex-col">
                <span className="text-white text-xl font-bold">0</span>
                <span className="text-base text-green-200">
                  Certificated Earn
                </span>
              </div>
            </div>
            {/* course process card */}
            <div className="xl:w-1/3 w-full bg-[#00294B] p-4 rounded-md flex gap-4 items-center ">
              <div className="w-[3rem] h-[3rem] bg-white rounded-full flex justify-center items-center">
                <span>
                  <IoTrendingUpOutline />
                </span>
              </div>
              <div className="flex flex-col">
                <span className="text-white text-xl font-bold">0</span>
                <span className="text-base text-green-200">Course Process</span>
              </div>
            </div>
          </div>

          <div className="w-full flex lg:flex-row flex-col gap-4">
            {/* class update */}
            <div className="lg:w-2/3 w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
              <h2 className="p-4 text-2xl font-bold text-white">
                Today's Class Update
              </h2>
              <span className="border-b border-[#22BEFF33]"></span>

              <div className="p-4">
                <h2 className="text-center text-white text-xl font-bold">
                  No Class Today
                </h2>
              </div>
            </div>
            {/* process */}
            <div className="lg:w-1/3 w-full flex flex-col gap-4 bg-[#00294B] rounded-md ">
              <h2 className="p-4 text-2xl font-bold text-white">Process</h2>
              <span className="border-b border-[#22BEFF33]"></span>

              <div className="p-4 flex flex-col gap-4">
                <div className="flex justify-center items-center">
                  <CircularProgress percentage={100} />
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-[1.5rem] h-[1.5rem] rounded-md bg-[#22BEFF]"></div>
                  <span className="text-sm text-white">Complete course</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* activitis */}
        <div className="lg:w-1/4 w-full flex flex-col gap-4 bg-[#00294B] rounded-md ">
          <h2 className="p-4 text-2xl font-bold text-white">Activites</h2>
          <span className="border-b border-[#22BEFF33]"></span>
        </div>
      </div>
      {/* main-2 */}
      <div className="flex flex-col gap-4 bg-[#00294B] rounded-md">
        <div className="flex justify-between items-center p-4">
          <h2 className=" text-2xl font-bold text-white">Ongoing Classes</h2>
          <Link to="/" className="text-xl font-bold text-[#22BEFF]">
            View Course
          </Link>
        </div>
        <span className="border-b border-[#22BEFF33]"></span>

        <div className="p-4">{/* content */}</div>
      </div>
    </div>
  );
};

export default Dashboard;
